export function detectIOS() {
  return /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !window.MSStream
}

export function toLatLngArray(coordinates) {
  if (coordinates.lat && coordinates.lng) {
    return [coordinates.lat, coordinates.lng]
  } else if (coordinates.length === 2) {
    return [...coordinates].reverse()
  }
  return [0, 0]
}

export function redirectToLogin() {
  navigateTo(window.location.origin + '/mein-oeamtc/login?redirect=' + window.location.href)
}

export function navigateTo(path) {
  window.location.href = path
}

export function getExternalAppointmentBaseUrl() {
  const URLS = {
    test: 'https://beta.oeamtc.at',
    prod: 'https://www.oeamtc.at',
  }
  const ORIGIN = window.location.origin

  if (process.env.NODE_ENV === 'development') {
    return URLS.test
  }

  if (ORIGIN.includes('webint')) {
    return URLS.test
  }
  if (ORIGIN.includes('beta')) {
    return URLS.test
  }
  return URLS.prod
}
